package com.devi3east.bashbuddy.account.organization.navigation

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.navigation.NavGraphBuilder
import androidx.navigation.compose.composable
import androidx.navigation.compose.currentBackStackEntryAsState
import com.devi3east.bashbuddy.features.app.data.AppState
import com.devi3east.bashbuddy.features.app.data.Screen
import com.devi3east.bashbuddy.features.common.ui.components.Loader
import com.devi3east.bashbuddy.account.organization.ui.OrganizationRoute
import com.devi3east.bashbuddy.auth.domain.models.UserType

fun NavGraphBuilder.organizationNavGraph(
    appState: AppState
) {
    composable(Screen.OrganizationScreen.route) {
        OrganizationNavEntry(
            appState = appState
        )
    }
}

@Composable
private fun OrganizationNavEntry(
    appState: AppState
) {
    val uiState by appState.authViewModel.uiState.collectAsState()
    val profile = uiState.profile
    val token = uiState.token

    val navBackStackEntry by appState.navController.currentBackStackEntryAsState()
    val currentRoute = navBackStackEntry?.destination?.route

    // 🚫 Only redirect if NOT already going somewhere safe
    if (token.isNullOrBlank()) {
        LaunchedEffect(Unit) {
            if (currentRoute != Screen.EventsScreen.route) {
                appState.navController.navigate(Screen.SignInScreen.route) {
                    popUpTo(0)
                }
            }
        }
        return
    }

    if (profile == null) {
        Loader()
        return
    }

    if (profile.userType != UserType.ORGANIZATION) {
        LaunchedEffect(Unit) {
            appState.navController.navigate(Screen.ProfileScreen.route)
        }
        return
    }

    OrganizationRoute(
        appState = appState,
        profile = profile
    )
}